import React, { FC, useCallback, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import styles from './index.module.scss';
import { Button } from 'src/common';
import { useTranslation } from 'react-i18next';
import { faPlus } from '@fortawesome/pro-light-svg-icons';
import CreateCustomBidFieldModal from '../../CreateCustomBidFieldModal';
import { TenderBoxFieldType } from '@tendium/prom-types/tender';
import CategoryItem from '../CategoryItem';
import { ICustomBidField } from 'src/models/company/CustomBidFields/types';
import { BlockEmpty } from 'src/shared';

interface IProps {
  icon: IconDefinition;
  color?: string;
  type: TenderBoxFieldType;
  items: ICustomBidField[];
  readOnly: boolean;
}

export const Category: FC<IProps> = props => {
  const { icon, type, color, items, readOnly } = props;
  const { t } = useTranslation();

  const [modalVisible, setModalVisible] = useState(false);

  const onShowModal = useCallback(() => {
    setModalVisible(true);
  }, []);

  const onHideModal = useCallback(() => {
    setModalVisible(false);
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <FontAwesomeIcon icon={icon} className={styles.icon} style={{ color }} />
        <h2 className={styles.title}>{t(`Tenders.TenderBoxFieldType.${type}`)}</h2>
      </div>
      <div className={styles.content}>
        {items?.length && (
          <div className={styles.list}>
            {items.map(item => (
              <CategoryItem key={item.id} item={item} readOnly={readOnly} />
            ))}
          </div>
        )}

        {readOnly && !items?.length && <BlockEmpty />}

        {!readOnly && (
          <Button onClick={onShowModal} icon={<FontAwesomeIcon icon={faPlus} />}>
            {t('CustomBidFields.addVariable', { variable: t(`Tenders.TenderBoxFieldType.${type}`).toLowerCase() })}
          </Button>
        )}
      </div>
      {modalVisible && <CreateCustomBidFieldModal onClose={onHideModal} type={type} />}
    </div>
  );
};

export default Category;
